export const ROLES = {
  ADMIN: 'ADMIN',
  SUPER_ADMIN: 'SUPER_ADMIN',
  PICKER: 'PICKER',
  // Fresh Inventory module roles. FRESH_STOCKER is mobile-app only and holds no
  // admin pages at all; FRESH_REPORT can only be granted the Fresh Reports
  // page. Which pages each may hold is served by the backend
  // (GET /users/allowed-pages), not hardcoded here.
  FRESH_STOCKER: 'FRESH_STOCKER',
  FRESH_REPORT: 'FRESH_REPORT',
} as const

// Human-friendly labels for the raw role values (used in the users grid, etc.)
//
// FRESH_STOCKER was called FRESH_STAFF until Nov 2026. The stored value was
// renamed with it, so any user document still holding 'FRESH_STAFF' must be
// migrated - the API's role enum no longer accepts the old value and the
// mobile auth middleware will not recognise it.
export const ROLE_LABELS: Record<string, string> = {
  [ROLES.ADMIN]: 'Admin',
  [ROLES.SUPER_ADMIN]: 'Super Admin',
  [ROLES.PICKER]: 'Picker',
  [ROLES.FRESH_STOCKER]: 'Fresh Stocker',
  [ROLES.FRESH_REPORT]: 'Fresh Report',
}

/**
 * Roles that sign in to the Fresh mobile app rather than the admin site.
 * A user on one of these never goes through the approval-manager OTP step, so
 * the Approval Manager field does not apply to them.
 */
export const FRESH_MOBILE_ONLY_ROLES: string[] = [ROLES.FRESH_STOCKER]

/**
 * Every role that belongs to the Fresh Inventory module. Used to hide the
 * GrandPOS and SAP settings on the user form - none of them reach a Fresh
 * user, so showing them only invites a meaningless grant.
 */
export const FRESH_ROLES: string[] = [ROLES.FRESH_STOCKER, ROLES.FRESH_REPORT]
